import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardService } from '../services/dashboard.service';

@Injectable({ providedIn: 'root' })
export class FormResolver implements Resolve<any> {
  constructor(private dashboardService: DashboardService) {}

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<any>|Promise<any>|any {
    const hash = route.paramMap.get('hash');
    return this.dashboardService.validateHash(hash);
  }
}
